import { css, type CSSObject } from '@emotion/react'
import { Color, wideGamutColor, ZIndex } from '@opallabs/gem'
import { type WithRequiredTheme } from '@opallabs/lapidary'

export const overlay = css({
  position: 'fixed',
  insetBlockEnd: 0,
  insetInlineStart: 0,
  inlineSize: '100vi',
  blockSize: '100vb',
  zIndex: ZIndex.Shroud.Overlay,
})

export const overlayDynamic = ({ theme }: WithRequiredTheme): CSSObject => ({
  backgroundColor: wideGamutColor(Color[theme].Surface.N200, 0.9),
})
